module.exports = __webpack_public_path__ + "static/media/earn_and_redeem_teal.c05b33e5.svg";